//Regular expression to match Wistia video URL
export const GET_WISTIA_VIDEO_ID_REGEX =
  /^https:\/\/(?:[^.]+\.)*wistia\.(?:com\/(?:medias|embed)\/|net\/embed\/iframe\/)([a-zA-Z0-9_-]+)$/;

export const VERIFY_WISITA_LINK_REGEX =
  /^https:\/\/(?:[^.]+\.)*wistia\.(?:com|net)\/(?:medias|embed\/iframe|embed)\/[a-zA-Z0-9_-]+$/;

export const VERIFY_YOUTUBE_LINK_REGEX =
  /(?:(?:http|https):\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/([A-Za-z0-9-_\\.]+)/im;
